//
//  This middleware handle logic / server call when user jwt need to be refreshed
//

import jwtDecode from 'jwt-decode';
import { nowTimestamp } from '../utils/dateUtils';
import { LOCALSTORAGE_KEY_AUTH_TIMESTAMP } from '../services/authentication/constants';
import { resfreshUserToken } from '../services/authentication/refresh/actions';
import { REFRESH_TOKEN_SUCCESS } from '../services/authentication/refresh/constants';
import { SUCCESS_LOGIN } from '../services/authentication/login/constants';

export const refreshTokenIfNeeded = ({ dispatch, getState }) => next => action => {
    try {
        const now = nowTimestamp();

        if (action.type === SUCCESS_LOGIN || action.type === REFRESH_TOKEN_SUCCESS) {
            window.localStorage.setItem(LOCALSTORAGE_KEY_AUTH_TIMESTAMP, now);
            return next(action);
        }

        const authTimestamp = window.localStorage.getItem(LOCALSTORAGE_KEY_AUTH_TIMESTAMP);
        const token = getState().authentication.token;

        if (token && authTimestamp) {
            const tokenExp = jwtDecode(token).exp;
            const authTime = Number(authTimestamp);
            if (tokenExp > now && now - authTime > (tokenExp - authTime) / 2) {
                window.localStorage.setItem(LOCALSTORAGE_KEY_AUTH_TIMESTAMP, now);
                dispatch(resfreshUserToken());
            }
        }

        return next(action);
    } catch (err) {
        console.error('localStorage error : ', err);
    }
};

export default refreshTokenIfNeeded;



// WEBPACK FOOTER //
// ./src/middlewares/tokenRefresher.js